import React from 'react';
import { Link } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faAdd, faArrowLeft, faShareAlt, faPingPongPaddleBall, faList12, faArrowCircleLeft, faQrcode } from '@fortawesome/free-solid-svg-icons';
import walletimage from '../../assets/pageimages/Wallet.webp';
import UploadImage from '../../components/UploadImage';

function WalletHome() {
  return (
    <div>
      <div className="min-h-full py-8 bg-black p-2 text-white [&_p]:text-white">
        <h2 className='text-sm lg:text-xl font-bold text-white text-center mb-2'>💰 Think5Whys Purse / Wallet</h2>

        <div className="min-h-[100vh] px-4">
          {/* <div className="flex justify-center mb-6">
            <img
              id="wallet-id"
              src={walletimage}
              alt="Wallet"
              style={{width:'300px', height: 'auto'}}
              className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-m shadow-md" 
            />
          </div> */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 place-items-center">
            <Link 
              to="/wallet-mywallet" 
              className="flex items-center text-white w-full text-xs lg:text-sm font-semibold bg-gray-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faWallet} className="mr-2" />
              My Think5Whys Purse / Wallet
            </Link>
            <Link 
              to="/wallet-topup" 
              className="flex items-center text-white w-full text-xs lg:text-sm font-semibold bg-green-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faAdd} className="mr-2" />
              Topup
            </Link>
            <Link 
              to="/wallet-mywallettemp" 
              className="flex items-center text-white w-full text-xs lg:text-sm font-semibold bg-green-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faList12} className="mr-2" />
              Pay by Other Method
            </Link>
            {/* <Link 
              to="/wallet-paytemp" 
              className="flex items-center text-white text-xs lg:text-sm font-semibold bg-green-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faQrcode} className="mr-2" />
              Pay Now by Other Method
            </Link> */}
            {/* <Link 
              to="/wallet-fromtemp" 
              className="flex items-center text-white text-xs lg:text-sm font-semibold bg-green-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faArrowCircleLeft} className="mr-2" />
              Bring Other Payment to Wallet
            </Link>             */}
            <Link 
              to="/wallet-transfer" 
              className="flex items-center text-white w-full text-xs lg:text-sm font-semibold bg-blue-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
              Think5Whys Purse / Wallet Transfer
            </Link>
            <Link 
              to="/wallet-pockettransfer" 
              className="flex items-center text-white w-full text-xs lg:text-sm font-semibold bg-blue-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
              Transfer to ThinkAIInsight Pocket
            </Link>
            {/* <Link 
              to="/wallet-shared" 
              className="flex items-center text-white text-xs lg:text-sm font-semibold bg-blue-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faShareAlt} className="mr-2" />
              Shared
            </Link> */}
            {/* <Link 
              to="/wallet-points" 
              className="flex items-center text-white text-xs lg:text-sm font-semibold bg-blue-600 hover:bg-yellow-200 rounded-m px-4 py-2 mb-2 sm:mb-0 transition-transform transform hover:scale-105"
            >
              <FontAwesomeIcon icon={faPingPongPaddleBall} className="mr-2" />
              Points
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletHome;
